import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParams } from "@utils/http-util";
import { QueryParameter } from "@idw-types/common";

export const getWorkflowSankeyResultsRequest = async (
    queryParameters: Array<QueryParameter>
): Promise<{ data: Array<[string, string, number]>, error: any }> => {
    const route = apiRoutes.reports.workflowUsageDetails.workflowSankeyResults;

    const { data, error }: { data?: any, error?: any } = await handleRequestWithQueryParams(RequestTypes.GET, route, queryParameters);
    return { data, error };
};